import { useContext, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import { Box, AppBar as MuiAppBar, Toolbar, Stack } from "@mui/material";

import AlertVerify from "./AlertVerify";
import RewardModal from "./RewardModal";
import Footer from "./Footer";
import { NavDesktop, NavDesktopDrawer } from "./Nav/NavDesktop";
import NavMobile from "./Nav/NavMobile";
import SessionContext from "../contexts/session";

import BtnConnect from "./ButtonConnect";
import ChangeNetworks from "./ChangeNetworks";

export const drawerWidth = 240;

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  // zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function Layout() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const { account, user } = useContext(SessionContext);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        position="fixed"
        open={open}
        sx={{
          zIndex: { xs: theme.zIndex.drawer - 1, lg: theme.zIndex.drawer + 1 },
        }}
      >
              <div style={{ backgroundColor: 'yellow', color: 'black', textAlign: 'center', fontWeight: 'bold', fontSize: '1rem', width: '100%', flexShrink: 0 }}>
        SITE FOR PORTFOLIO PURPOSES ONLY - NO LONGER OPERATING
      </div>
        <Toolbar>
          <NavMobile />
          <NavDesktop style={{}} open={open} handleDrawerOpen={handleDrawerOpen} />
          <Link to="/">
            <img
              src="/img/logo248.svg"
              height={36}
              style={{ display: "block" }}
            />
          </Link>
          <Stack
            spacing={1}
            direction="row"
            sx={{ ml: "auto", alignItems: "center" }}
          >
            <ChangeNetworks />
            <BtnConnect />
          </Stack>
        </Toolbar>
      </AppBar>
      <NavDesktopDrawer open={open} handleDrawerClose={handleDrawerClose} />
      <Stack
        component="main"
        sx={{ flexGrow: 1, overflow: "auto", minHeight: "100vh" }}
      >
        <DrawerHeader />
        <Stack spacing={4} sx={{ px: { xs: 1, sm: 4 }, py: 4 }}>
          {account && !user?.verified && <AlertVerify />}
          {account && user?.verified && <RewardModal />}
          {/* <WrongNetwork /> */}
          <Outlet />
        </Stack>
        <Box sx={{ flexGrow: 1 }} />
        <Footer />
      </Stack>
    </Box>
  );
}
